import React from 'react';
import { Benchmark } from '../utils/analytics';
interface PeerBenchmarkProps {
  benchmark: Benchmark;
  chosen?: string;
  revealed: boolean;
}

/**
 * The immediate reward for answering. Shows the real split once enough
 * responses exist; until then it says so plainly rather than inventing numbers.
 */
export function PeerBenchmark({
  benchmark,
  chosen,
  revealed
}: PeerBenchmarkProps) {
  if (!benchmark.ready) {
    const collected = Math.min(benchmark.total, 20);
    return <div className={`transition-[opacity,transform] duration-300 ease-out ${revealed ? 'translate-y-0 opacity-100' : 'translate-y-1.5 opacity-0'}`} data-id="element-80" data-mp="2ca6qxmzdogg3">
        <p className="font-body text-xs leading-snug text-white/55" data-id="element-81" data-mp="239qugxh1y9kq">
          Peer results appear once 20 colleagues have answered.
        </p>
        <div className="mt-2.5 h-0.5 w-full overflow-hidden rounded-full bg-white/10" data-id="element-82" data-mp="3spzzujwb72ei">
          <span className="block h-full rounded-full bg-solventum-primary transition-[width] duration-500 ease-out" style={{
          width: `${collected / 20 * 100}%`
        }} data-id="element-83" data-mp="1hccjyeid54b" />
        </div>
        <p className="mt-2 font-body text-[10px] uppercase tracking-[0.18em] text-white/30" data-id="element-84" data-mp="2lk4ubt0bl3hz">
          {collected} of 20
        </p>
      </div>;
  }
  return <ul className="flex flex-col gap-2" data-id="element-85" data-mp="2ucpya2zal5mr">
      {benchmark.rows.map((row, index) => {
      const isChosen = row.answer === chosen;
      const percent = Math.round(row.share * 100);
      return <li key={row.answer} className={`transition-[opacity,transform] duration-300 ease-out ${revealed ? 'translate-y-0 opacity-100' : 'translate-y-1.5 opacity-0'}`} style={{
        transitionDelay: `${index * 90}ms`
      }} data-id="element-86" data-mp="22mk6mp9akayy" data-mpi={index}>
            <div className="flex items-baseline justify-between" data-id="element-87" data-mp="3s0gu1yisitfo">
              <span className={`font-headline text-[11px] font-bold uppercase tracking-[0.16em] ${isChosen ? 'text-solventum-primary' : 'text-white/60'}`} data-id="element-88" data-mp="3s2tau8ctaxr5">
                {row.answer}
              </span>
              <span className={`font-headline text-[11px] font-bold tabular-nums ${isChosen ? 'text-solventum-primary' : 'text-white/60'}`} data-id="element-89" data-mp="2x7pump6cnzm">
                {percent}%
              </span>
            </div>
            <div className="mt-1.5 h-0.5 w-full overflow-hidden rounded-full bg-white/10" data-id="element-90" data-mp="3bfdnjchfw5so">
              <span className={`block h-full rounded-full transition-[width] duration-500 ease-out ${isChosen ? 'bg-solventum-primary' : 'bg-white/30'}`} style={{
            width: revealed ? `${percent}%` : '0%'
          }} data-id="element-91" data-mp="3gcxb53011uxa" />
            </div>
          </li>;
    })}
      <li className="pt-1 font-body text-[10px] uppercase tracking-[0.18em] text-white/30" data-id="element-92" data-mp="2snl160wvlitx">
        {benchmark.total} responses
      </li>
    </ul>;
}